import * as React from "react";
import { ExpandMore } from "@material-ui/icons";

//////////////////
// STYLES
//////////////////
const closedStyle: React.CSSProperties = {
  flexShrink: 0,
  transition: "transform .4s",
};
const openStyle: React.CSSProperties = {
  ...closedStyle,
  transform: "rotate(180deg)",
};

//////////////////
// COMPONENT
//////////////////
export const CardTopLineToggle = ({ open, onClick }: { open?: boolean; onClick?: () => void }) => {
  return <ExpandMore style={!!open ? openStyle : closedStyle} onClick={onClick} />;
};
